

































import { Component, Prop, Vue } from 'vue-property-decorator';

import Swiper, { Navigation, Thumbs, SwiperOptions } from 'swiper';
import PortalIcon from '@/components/icons/PortalIcon.vue';

Swiper.use([Navigation, Thumbs]);

const SLIDES_OPTIONS: SwiperOptions = {
  slidesPerView: 1,
  loop: false,
  centeredSlides: true,
  shortSwipes: true,
  spaceBetween: 40,
};

const THUMBS_OPTIONS: SwiperOptions = {
  slidesPerView: 3,
  loop: false,
  centeredSlides: false,
  shortSwipes: false,
  allowTouchMove: false,
  slideToClickedSlide: true,
  spaceBetween: 20,
};
@Component({
  components: { PortalIcon },
})
export default class GamePreviewSlides extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly slides!: Array<SlideConfig>;

  slider!: Swiper;

  thumbs!: Swiper;

  mounted() {
    this.thumbs = new Swiper(this.$refs.thumbs as HTMLElement, THUMBS_OPTIONS);

    this.slider = new Swiper(this.$refs.slider as HTMLElement, {
      ...SLIDES_OPTIONS,
      navigation: {
        nextEl: this.$refs.next as HTMLElement,
        prevEl: this.$refs.prev as HTMLElement,
      },
      thumbs: {
        swiper: this.thumbs,
      },
    });
  }

  beforeDestroy() {
    this.slider.destroy();
    this.thumbs.destroy();
  }
}
